import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";
import { FaFacebookF } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa6";
import { FaTiktok } from "react-icons/fa";

const Footer = () => {
  const [isSwitchToggle, setIsSwitchToggle] = useState(false);

  const setTheme = (color) => {
    document.getElementById("colorTheme").href =
      "assets/css/colors/" + color + ".css";
  };

  const toggleSwitcher = () => {
    setIsSwitchToggle(!isSwitchToggle);
  };

  // Scroll to top
  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const scrollNavigation = () => {
    const backToTop = document.getElementById("back-to-top");
    if (!backToTop) return;

    if (
      document.body.scrollTop > 100 ||
      document.documentElement.scrollTop > 100
    ) {
      backToTop.style.display = "inline";
    } else {
      backToTop.style.display = "none";
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", scrollNavigation, true);

    return () => {
      window.removeEventListener("scroll", scrollNavigation, true);
    };
  }, []);

  const office = [
    { city: "Denpasar Office", address : "Jl. Buluh Indah No.56, Pemecutan Kaja, Denpasar, Kota Denpasar, Bali 80111", map : "https://maps.app.goo.gl/gUN8RdMAPZrRVsK56" },
    { city: "Jakarta Branch Office", address : "Kantor MULA - Office & Commercial Space, Jl. Kemang Sel. Raya No.151, RT.4/RW.4 - Jakarta", map : "https://maps.app.goo.gl/t5GXgtZc3hFgyrWA9" },
    { city: "Tangerang Branch Office", address : "Sanctuary Bintaro Co Working Space, Ruko Emerald Boulevard Bintaro, Tangerang Selatan, Banten 15227", map : "https://maps.app.goo.gl/G7cFaA3dYKbiAfcx6" },
    { city: "Bandung Branch Office", address : "Point Lab Co-working Space, Jl. Banda No.30 - Bandung", map : "https://maps.app.goo.gl/4XX7s7DvdtYHJrpg7" },
    { city: "Medan Branch Office", address : "GoWork Sinar Mas Land Plaza Jl. Pangeran Diponegoro No.18 Lt. 10 Medan Polonia - Kota Medan", map : "https://maps.app.goo.gl/rvPPF5Qdq9kBKLK78" },
    { city: "Yogyakarta Branch Office", address : "Jl. Bintaran Kidul No.36, Wirogunan, Kec. Mergangsan, Kota Yogyakarta, Daerah Istimewa Yogyakarta 55151", map : "https://maps.app.goo.gl/jnvmifE4HatY8K8c8" },
    { city: "Surabaya Branch Office", address : "IdeaHub Coworking Space Voza Tower, Jl. Mayjen HR. Muhammad No.31, Putat Gede, Surabaya-Jawa Timur", map : "https://maps.app.goo.gl/9cR1bZhCH9mMzYE56" },
    { city: "Makassar Branch Office", address : "Bikin Bikin Creative Hub Mall Nipah, Jl. Urip Sumoharjo No.23C Panakkukang - Kota Makassar", map : "https://maps.app.goo.gl/b4ZkZrm4sNuHQ63E8" },
  ]    

  return (
    <section className="section footer" id="footer">
      <footer className="container">
          <div className='footer-social-media'>
            <h2 className='pe-2 mb-lg-0'><b>Follow us on</b></h2>
            <div className="social-links">
              <div>
                <a href="https://id-id.facebook.com/niec.indonesia/" target='_blank' className="facebook"><FaFacebookF color="#ae062a" /></a>
              </div>
              <div>
                <a href="https://www.instagram.com/niec_indonesia/" target='_blank' className="instagram"><FaInstagram color="#ae062a" /></a>
              </div>
              <div>
                <a href="https://www.tiktok.com/@niec_indonesia?lang=id-ID" target='_blank' className="instagram"><FaTiktok color="#ae062a" /></a>
              </div>              
            </div>
          </div>
          <div className='row my-4'>
            <div className='col-md-3'>
              <a href="https://niecindonesia.com/" target="_blank" rel="noopener noreferrer">
                <img 
                  src="assets/images/logo-white.webp" 
                  alt="niec-logo-white-color"
                  className="img-fluid logo-niec" 
                />              
              </a>
            </div>
            <div className='col-md-8'>
              <h6>Tentang NIEC INDONESIA</h6>
              <p>
                NIEC Indonesia adalah konsultan pendidikan luar negeri 
                terpercaya yang telah membantu ribuan siswa Indonesia 
                mewujudkan impian kuliah ke luar negeri. Dengan 8 cabang 
                di Indonesia di antaranya Medan, Tangerang, Jakarta, 
                Bandung, Yogyakarta, Surabaya, Makassar, dan Denpasar.
                Kami siap mendampingi perjalanan studimu dari A sampai Z.
              </p>
            </div>            
          </div>
          <div className='row footer-address'>
            {office.map((items, id) => (
              <div key={id} className='col-md-3 d-flex'>
                <a href={items.map} target='_blank' rel='noopener noreferrer'>
                  <h6>{items.city}</h6>
                  <p>{items.address}</p>
                </a>
                <span className='border-custom' />
              </div>
            ))}
          </div>   
          <div className='text-center mt-5'>
            © {new Date().getFullYear()} Copyright NIEC Indonesia. All Rights Reserved. CV Naresy Indonesia
          </div>       
      </footer>
      {/* scrollup button */}
      <Link
        to="#"
        onClick={scrollTop}
        className="back-to-top"
        id="back-to-top"
      >
        <i className="ti-angle-up"></i>
      </Link>
    </section>
  );
};

export default Footer;